// extracted by mini-css-extract-plugin
export default {"wrapper":"P_24q","title":"ApT2v","error":"C960Z"};